import React from "react";
import { OrderSummaryProps } from "../types/dashboard";
import PieCharts from "../PieCharts/PieCharts";

const OrderSummary: React.FC<OrderSummaryProps> = ({ title, orders, amount, received, outstanding = 0, timeRange, businessType }) => {
  return (
    <div className="rounded-xl shadow-md h-full flex flex-col bg-white">
      <div className="flex-1 p-4">
        <PieCharts
          title={title} 
          Orders={orders} 
          amount={amount} 
          ReceivedAmount={received} 
          OutstandingAmount={outstanding} 
          timeRange={timeRange}
          businessType={businessType}
        />
      </div>
    </div>
  );
};

export default OrderSummary;